export default __webpack_public_path__ + "static/media/gallery_06.7e8ede32.jpg";